export default __webpack_public_path__ + "static/media/portfolio6.4030d5c1.png";